import { Mui } from "@osu/react-ui";
import React from "react";
import { getSyncOptions, isAsyncDropdownSubtype } from "../../../util/functions";
import AsyncDropdown from "./AsyncDropdown";

function Dropdown(props = {}) {
  const { choices, id, value, label, onChange, callback, subtype, sectionState, error, helperText, dataField, description, onOptionSelected, ...rest } = props;

  const asynchronous = !!callback || isAsyncDropdownSubtype(subtype)
  
  if(asynchronous) {
    return <AsyncDropdown 
    id={id}
    value={value}
    label={label}
    subtype={subtype}
    callback={callback}
    onChange={onChange}
    sectionState={sectionState}
    error={error}
    {...rest}
    />
  }
  const syncOptions = getSyncOptions(subtype)
  const options = syncOptions?.length ? syncOptions : choices

  return (
    <Mui.FormControl variant="outlined" error={!!error} {...rest}>
      <Mui.InputLabel htmlFor={id} id={id + "-label"}>{label}</Mui.InputLabel>
      <Mui.Select
        labelId={id + "-label"}
        value={value?.value || value || ""}
        onChange={(event) => {
          const val = event?.target?.value
          const matchingOption = options.find(opt => opt.value === val)
          onChange(matchingOption || event)
          if(onOptionSelected) onOptionSelected(matchingOption);
        }}
        label={label}
        inputProps={{ id }}
      >
        {options.map(({ value, title, id }, index) => {
          return (
            <Mui.MenuItem key={`choice-${id}-${index}`} value={value}>
              {title}
            </Mui.MenuItem>
          );
        })}
      </Mui.Select>
      {description && <Mui.Typography className="margin-y-1" variant="body2" color="secondary">{description}</Mui.Typography>}
      <Mui.FormHelperText>{error}</Mui.FormHelperText>
    </Mui.FormControl>
  );
}

Dropdown.defaultProps = {
  choices: [],
  value: ''
}

export default Dropdown